import '@forest/native-diagnostics'

import './lib/posthog'
import {
  getProducts,
  getReceiptSystemAccountIdSafe,
  initializeNativeBridge,
  native,
  withPageLoadingRecovery,
} from '@forest/native-services'
import { closeAfterStartupFailure } from './lib/terminal-close'
import { defineCustomClientStrategy } from './paraglide/runtime'
import { appVersion, language, mock, platform } from './params'
import { api } from './services/api'
import { $receiptSystemAccountId } from './store/receipt-system-account-id'
import { setAnnualEarlyBirdProduct } from './store'
import { userInfoSource } from './store/user-info'

defineCustomClientStrategy('custom-queryParam', {
  getLocale: () => language,
  setLocale: () => {},
})

initializeNativeBridge({
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})

void getReceiptSystemAccountIdSafe(appVersion).then((id) => {
  $receiptSystemAccountId.set(id)
})

const userInfoPromise = userInfoSource.getReady()
// Daily content reveals on its own condition, which product initialization does
// not gate. A product read that is still recovering when the content appears
// keeps the presentation's original loading budget rather than ending with it.
const productsPromise = withPageLoadingRecovery(
  () =>
    getProducts({
      cacheKeyPrefix: 'dailyPaywall.products.v2',
      api,
      appVersion,
      platform,
      deferredUserInfo: userInfoPromise,
      env: import.meta.env.MODE as 'production' | 'staging' | 'dev',
      shouldMock: import.meta.env.DEV,
    }),
  { survivesReveal: true },
)

const useDevMock =
  import.meta.env.DEV || (import.meta.env.MODE === 'dev' && mock)

if (useDevMock) {
  productsPromise
    .then((products) => {
      const product = products.annualEarlyBird
      setAnnualEarlyBirdProduct(product)
      native.general.logEvent({
        event_name: 'plus_price_test_config',
        event_params: { product_id: String(product.product_id) },
      })
    })
    .catch(closeAfterStartupFailure)
} else {
  ;(async function init() {
    try {
      await userInfoPromise

      const products = await productsPromise
      const product = products.annualEarlyBird
      setAnnualEarlyBirdProduct(product)
      native.general.logEvent({
        event_name: 'plus_price_test_config',
        event_params: { product_id: String(product.product_id) },
      })
    } catch {
      closeAfterStartupFailure()
    }
  })()
}
